"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiActivityStatuses = {
    new: 0,
    scheduled: 1,
    completed: 2,
    uncompleted: 3
};
